import React, { useEffect, useState } from "react";
import { api } from "../../../Config/Api";

interface NotificationBarConfig {
  enabled: boolean;
  message: string;
  backgroundColor: string;
  textColor: string;
  scrolling: boolean;
  scrollSpeed: number;
}

const NotificationBar = () => {
  const [config, setConfig] = useState<NotificationBarConfig | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const { data } = await api.get("/notification-bar");
        setConfig(data);
      } catch (error) {
        console.log("Failed to load notification bar config", error);
      }
    };

    fetchConfig();
  }, []);

  if (!config?.enabled || !config?.message?.trim()) {
    return null;
  }

  return (
    <div
      className="w-full overflow-hidden px-3 sm:px-4 lg:px-6 min-h-[36px] flex items-center justify-center"
      style={{
        backgroundColor: config.backgroundColor,
        color: config.textColor,
      }}
    >
      {config.scrolling ? (
        <div
          className="notification-marquee whitespace-nowrap py-2 text-xs sm:text-sm font-medium"
          style={{
            animationDuration: `${config.scrollSpeed || 18}s`,
          }}
        >
          {config.message}
        </div>
      ) : (
        <div className="w-full text-center text-xs sm:text-sm font-medium py-2 break-words">
          {config.message}
        </div>
      )}
    </div>
  );
};

export default NotificationBar;